import Player from '@vimeo/player';

import { initNavigation } from "./modules/navigation";

import { initNavigationLang} from "./modules/navigation-lang";

import { initDropdown } from "./molecules/dropdown";

import { initVideo } from "./molecules/video";

import { slider } from "./molecules/slider";

import { initHeroVideo } from "./molecules/hero-video";

import { initLeadership } from "./molecules/leadership";

import { initAwards } from "./molecules/awards";

// Load all JS after Content Load
document.addEventListener("DOMContentLoaded", function () {
	initNavigation();
	initDropdown();
	initVideo();
	slider();
	initHeroVideo();
	initLeadership();
	initAwards();
	initNavigationLang();

	window.Player = Player;
});
